@if (visInnkallingIkkeSendtTilNoen()) {
  @if (antallDeltakere() == 1) {
    <span>{{ '1 deltaker - Innkalling ikke sendt'|translate }} </span>
  } @else {
    <span>{{ '{antallDeltakere} deltakere - Innkalling ikke sendt'|translate: {antallDeltakere: antallDeltakere()} }} </span>
  }
} @else if (visInnkallingIkkeSendtTilAlle()) {

  @if (antallDeltakere() == 1) {
    <span>{{ '1 deltaker - {antallInvitasjonSendtEllerGodtattEllerAvslaatt} innkalt'|translate:{antallInvitasjonSendtEllerGodtattEllerAvslaatt: antallInvitasjonSendtEllerGodtattEllerAvslaatt()} }} </span>
  } @else {
    <span>{{
        '{antallDeltakere} deltakere - {antallInvitasjonSendtEllerGodtattEllerAvslaatt} innkalt'|translate:{
          antallDeltakere: antallDeltakere(),
          antallInvitasjonSendtEllerGodtattEllerAvslaatt: antallInvitasjonSendtEllerGodtattEllerAvslaatt()
        }
      }} </span>
  }
} @else if (visInnkallingSendt()) {
  @if (antallDeltakere() == 1) {
    <span>{{ '1 deltaker - {antallGodtatt} godtatt'|translate:{antallGodtatt: antallGodtatt()} }} </span>
  } @else {
    <span>{{
        '{antallDeltakere} deltakere - {antallGodtatt} godtatt'|translate:{
          antallDeltakere: antallDeltakere(),
          antallGodtatt: antallGodtatt()
        }
      }} </span>
  }
} @else if (visInnkallingSendtBareAvslaatte()) {
  @if (antallDeltakere() == 1) {
    <span>{{ '1 deltaker - {antallAvslaatt} avslått'|translate:{antallAvslaatt: antallAvslaatt()} }} </span>
  } @else {
    <span>{{
        '{antallDeltakere} deltakere - {antallAvslaatt} avslått'|translate:{
          antallDeltakere: antallDeltakere(),
          antallAvslaatt: antallAvslaatt()
        }
      }} </span>
  }
}


